var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProductsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE4BC",
    d: "M5.18 7.066l7.623 4.358c.117.067.26.067.377 0l7.637-4.365a.38.38 0 00-.001-.659l-7.629-4.352a.382.382 0 00-.376 0L5.18 6.408a.38.38 0 000 .659z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M4.05 8.351a.38.38 0 01.519-.14l7.628 4.367a.38.38 0 01.19.33v8.716a.38.38 0 01-.568.33l-7.628-4.361a.381.381 0 01-.191-.33V8.541c0-.066.017-.131.05-.189zm17.57-.191c.21 0 .38.17.38.38v8.716a.381.381 0 01-.191.33l-7.628 4.367a.382.382 0 01-.569-.33v-8.722c0-.136.073-.262.191-.33l7.629-4.361a.375.375 0 01.188-.05z"
  }))));
}

export default SvgProductsActive;